import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import withStore from '../../../withStore';

import useMount from '../../../../hooks/useMount';
import useJanitor from '../../../../hooks/useJanitor';

import analytics from '../../../../modules/analytics';
import StateManager from '../../../../modules/user/stateManager';

import {
  MONTHLY_GOAL_EXPIRY_DAYS,
  MONTHLY_GOAL_REMINDER_DAYS,
  MONTHLY_GOAL_SURVEY_KEY,
} from '../../MonthlyGoal';

import ManageGoalNotification from './ManageGoalNotification';

export const ManageGoalNotificationContainer = ({
  linkTo,
  notification,
}) => {
  const [goal, setGoal] = useState();
  const [showReminder, setShowReminder] = useState();
  const [loading, setLoading] = useState(true);

  const janitor = useJanitor();

  useMount(async () => {
    const value = await janitor.addPromise(StateManager.getActionValue(MONTHLY_GOAL_SURVEY_KEY));

    const showSetAGoal = !value || !value.time || moment.utc(value.time).add('days', MONTHLY_GOAL_EXPIRY_DAYS) < moment.utc();
    const showGoalReminder = value && value.time && moment.utc(value.time).add('days', MONTHLY_GOAL_REMINDER_DAYS) < moment.utc();

    if (showSetAGoal) {
      analytics.track('pro_notifications_set_goal_view');
    } else if (showGoalReminder) {
      analytics.track('pro_notifications_goal_reminder_view');
      setGoal(value);
      setShowReminder(true);
    }

    setLoading(false);
  });

  if (loading) {
    return null;
  }

  return (
    <ManageGoalNotification
      goal={goal}
      showReminder={showReminder}
      linkTo={linkTo}
      notification={notification}
    />
  );
};

ManageGoalNotificationContainer.propTypes = {
  notification: PropTypes.object.isRequired,
  linkTo: PropTypes.func,
};

ManageGoalNotificationContainer.defaultProps = {
  linkTo: () => {},
};

const mapDispatchToProps = dispatch => ({
  linkTo: (route, params, notify = true) => {
    dispatch.route.go({
      route,
      params,
      notify,
    });
  },
});

export default withStore(connect(null, mapDispatchToProps)(ManageGoalNotificationContainer));
